"use client";

import { useContext } from "react";
import { UserContext } from "@/contexts/user-context";
import { CommentInput } from "@/components/common/anon-comments/component/comment-input/comment-input";

export const AnonComments = ({
  comments,
  onSend,
  showInput,
}: {
  comments: AnonCommentVM[];
  onSend: (replyTo: number | null) => (content: string) => void;
  showInput: boolean;
}) => {
  const { isVerified } = useContext(UserContext);

  return (
    <div className={"mt-6 flex flex-col gap-6"}>
      {comments.map((comment) => {
        const { content, id, author } = comment;
        return (
          <div
            className={"border-l-[1px] border-zinc-500 px-4 py-2 text-sm"}
            key={id}
          >
            <div className={"mb-2 font-semibold"}>{author.displayName}</div>
            <div className={""}>{content}</div>
          </div>
        );
      })}
      {isVerified && showInput && <CommentInput onSend={onSend(null)} />}
    </div>
  );
};
